import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/storage'

const {
  REACT_APP_FIREBASE_APIKEY,
  REACT_APP_FIREBASE_AUTHDOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECTID,
  REACT_APP_FIREBASE_STORAGEBUCKET,
  REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
} = process.env
const env = process.env.NODE_ENV

let settings = {}

// if (env === 'development') {
//   settings.host = 'localhost:8080'
// }

const config = {
  apiKey: REACT_APP_FIREBASE_APIKEY,
  authDomain: REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: REACT_APP_FIREBASE_PROJECTID,
  storageBucket: REACT_APP_FIREBASE_STORAGEBUCKET,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
}
firebase.initializeApp(config)

firebase.firestore().settings(settings)
firebase.firestore()
firebase.functions()
firebase.storage()

// firebase
//   .firestore()
//   .collection('profiles')
//   .doc('ZCBDaE18BmdszjDaxBrH3xtZDTt2')
//   .set({
//     role: 'admin',
//     company: {
//       label: 'Expansive Coworking',
//       value: 'expansive-coworking',
//     },
//     default_location: {},
//     disabled: false,
//     email_address: 'austin@studioscience.com',
//     first_name: 'Austin',
//     last_name: 'Woodall',
//     first_time_user: false,
//     floor_number: 6,
//     job_title: 'Developer',
//     locations: null,
//   })

let dir
if (env === 'production') {
  dir = 'https://us-central1-novel-app-d6252.cloudfunctions.net'
} else {
  dir = 'http://localhost:5000/novel-app-d6252/us-central1'
}

export const FunctionsDir = dir
export const Firebase = firebase
